import styled from 'styled-components'

const StyleNotication = styled.div`
 position: relative !important;
 top: -7px !important;
 left: 27px !important;
 transform: rotate(-46deg)
 `
 export default StyleNotication